import { Injectable } from '@angular/core';
import { Firestore, doc, getDoc, setDoc } from '@angular/fire/firestore';

export interface AppSyncEnv {
  url: string;
  region: string;
  desc: string;
}

interface DevSettingsDocument {
  appsyncEnv?: AppSyncEnv;
}

const COLLECTION = 'dev_settings';

@Injectable({ providedIn: 'root' })
export class DevEnvPreferenceService {
  constructor(private readonly firestore: Firestore) {}

  async read(uid: string): Promise<AppSyncEnv | null> {
    const snapshot = await getDoc(doc(this.firestore, COLLECTION, uid));
    const data = snapshot.data() as DevSettingsDocument | undefined;
    return data?.appsyncEnv ?? null;
  }

  async save(uid: string, env: AppSyncEnv): Promise<void> {
    const payload: DevSettingsDocument = { appsyncEnv: env };
    await setDoc(
      doc(this.firestore, COLLECTION, uid),
      payload,
      { merge: true },
    );
  }
}
